import { useState, type ReactNode } from "react";
import { HelpCircle } from "lucide-react";
import { useDismissable } from "../../../hooks/useDismissable";

// Boton "?" que despliega ayuda on-demand. Reemplaza los parrafos de ayuda
// siempre-visibles que ensuciaban las cards del admin: el dueño pidio "menos
// texto a simple vista; un ? nomas para desplegar esa info".
//
// El contenido debe ser texto/inline (se renderiza dentro de un <span> para
// poder ir al lado de un titulo sin romper el flujo). Para varias lineas usar
// "\n" — el popover respeta los saltos (whitespace-pre-line).
export function HelpPopover({
  children,
  label = "Mas info",
  align = "left",
}: {
  children: ReactNode;
  label?: string;
  align?: "left" | "right";
}) {
  const [open, setOpen] = useState(false);
  const ref = useDismissable<HTMLSpanElement>(open, () => setOpen(false));

  return (
    <span className="relative inline-flex align-middle" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={label}
        aria-expanded={open}
        className="inline-flex h-5 w-5 items-center justify-center rounded-full text-white/40 transition hover:bg-white/10 hover:text-white"
      >
        <HelpCircle className="h-4 w-4" />
      </button>
      {open && (
        <span
          role="tooltip"
          className={`absolute top-full z-30 mt-1 block w-64 whitespace-pre-line rounded-lg border border-white/15 bg-[#1a1540] p-3 text-xs font-normal leading-relaxed text-white/80 shadow-2xl ${
            align === "right" ? "right-0" : "left-0"
          }`}
        >
          {children}
        </span>
      )}
    </span>
  );
}
